/* eslint-disable no-undef */
/* eslint-disable jquery/no-class */
/* eslint-disable jquery/no-html */
/* eslint-disable jquery/no-find */
/* eslint-disable jquery/no-text */
/* eslint-disable jquery/no-ajax */
import throttle from './throttle';
import { initSearchIconClick, getPageOffset, isKeyboardOpen } from './header';

const SCROLL_INTERVAL = 150;

/**
 * Initialise mobile search behaviour on the header
 */
const initMobileSearch = () => {
  const header = document.querySelector('.header-sticky');
  const searchIconElement = document.querySelector('.header-element__search[data-toggle="search-mobile"]');
  const isPDP = document.body.classList.contains('new-pdp');
  const accountIcon = document.querySelector('.header-element__user.left');
  const isHomePage = document.querySelector('.page[data-action="Home-Show"]');

  if (!header || !searchIconElement) {
    return;
  }

  const setInitialState = () => {
    if (isHomePage || isPDP) {
      searchIconElement.classList.add('d-none');
    } else {
      searchIconElement.classList.add('d-block');
    }
    if (accountIcon) accountIcon.classList.add('d-none');
  };

  setInitialState();

  // Toggle search icon and other icons based on scroll position (after header-banner)
  window.addEventListener('scroll', throttle(() => {
    if (isKeyboardOpen()) return;
    const PAGE_OFFSET = getPageOffset();

    if (window.pageYOffset < PAGE_OFFSET && !isPDP) {
      searchIconElement.classList.add('d-block');
      searchIconElement.classList.remove('d-none');
    } else {
      searchIconElement.classList.remove('d-block');
      searchIconElement.classList.add('d-none');
    }
  }, SCROLL_INTERVAL));

  // On search icon click, scroll down to show search bar
  initSearchIconClick();
};

const initComponents = () => {
  initMobileSearch();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initComponents);
} else {
  initComponents();
}
